import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const VehicleTrafficService = {
    getVehicleTraffic: async (d, showMetadata = false) => {
        return axios.get(`${API_URL}/vehicle_traffic/search`, {
            params: { d, show_metadata: showMetadata ? 1 : 0 }
        }).then(({ data }) => data)
    }
};

export default VehicleTrafficService;
